import { GetClimateRiskV2ReportQuery } from '@predium/client-graphql';
import { RiskScenarioEnum } from './mapping';

export enum ViewModeEnum {
  RISK_CATEGORY = 'Risk Category',
  PERCENTAGE = 'Percentage',
  MONETARY = 'Monetary',
}

type ClimateRiskV2Report = NonNullable<GetClimateRiskV2ReportQuery['readClimateRiskV2Report']['data']>;
export type ClimateRiskV2ReportFiles = ClimateRiskV2Report['files'];
export type Scenarios = ClimateRiskV2Report['scenarios'];
type Scenario = Scenarios[number];
type Risks = Scenario['risks'];
export type RiskWithScenario = Risks[number] & { scenario: RiskScenarioEnum };
